import { format, isToday, isTomorrow, differenceInCalendarDays } from 'date-fns'
import type { PreferredHourCycle } from '@shared/ipc/routers/BaseIpc.router'
import { formatUserTime } from './user-time-format'

function formatTime(date: Date, hourCycle: PreferredHourCycle | null): string {
  return formatUserTime(date, hourCycle, { omitZeroMinutes: true })
}

export function formatScheduledAt(date: Date, hourCycle: PreferredHourCycle | null = null): string {
  const now = new Date()
  const daysOut = differenceInCalendarDays(date, now)

  if (isToday(date)) {
    return `Due today, ${formatTime(date, hourCycle)}`
  }

  if (isTomorrow(date)) {
    return `Due tomorrow, ${formatTime(date, hourCycle)}`
  }

  if (daysOut >= 2 && daysOut <= 6) {
    return `Due ${format(date, 'EEEE')}, ${formatTime(date, hourCycle)}`
  }

  if (daysOut >= 7 && daysOut <= 13) {
    return `Due next ${format(date, 'EEEE')}, ${formatTime(date, hourCycle)}`
  }

  return `Due ${format(date, 'MMM d')}, ${formatTime(date, hourCycle)}`
}
